import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthService } from '../services/api';
import LegalCheckboxes from './LegalCheckboxes';
import logo from '../assets/logo.png'; // Importer le logo
import Message from './Message';

const SignUp = () => {
    const [userData, setUserData] = useState({
        name: '',
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [docs, setDocs] = useState(null);
    const [accepted, setAccepted] = useState({ cgu: false, dpa: false });
    const navigate = useNavigate();

    const loadDocs = () => AuthService.getLegal().then((legal) => {
        setDocs(legal);
        setAccepted({ cgu: false, dpa: false });
    });

    useEffect(() => {
        loadDocs().catch(() => setError('Impossible de charger les conditions d\'utilisation. Veuillez réessayer.'));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await AuthService.signUp({
                ...userData,
                accept_cgu: true,
                accept_dpa: true,
                cgu_version: docs.cgu.version,
                dpa_version: docs.dpa.version,
            });
            navigate('/dashboard'); // Redirection vers le tableau de bord après inscription
        } catch (err) {
            console.error('Erreur d\'inscription:', err);
            if (err.response?.status === 409) {
                await loadDocs().catch(() => {});
                setError('Les documents ont été mis à jour, veuillez les relire et les accepter à nouveau.');
            } else {
                setError(
                    err.response?.data?.error ||
                    'Une erreur est survenue lors de l\'inscription. Veuillez réessayer.'
                );
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="signup-container">
            <img src={logo} alt="Logo de l'application" style={{ maxWidth: '150px', display: 'block', margin: '0px auto 20px auto' }} /> {/* Afficher le logo */}
            <h2>Créer un compte</h2>
            {error && <Message>{error}</Message>}

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="name">Nom de l'organisation</label>
                    <input
                        type="text"
                        id="name"
                        name="name"
                        value={userData.name}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={userData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="password">Mot de passe</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={userData.password}
                        onChange={handleChange}
                        required
                    />
                </div>

                {docs && (
                    <LegalCheckboxes
                        docs={docs}
                        types={['cgu', 'dpa']}
                        checked={accepted}
                        onChange={(type, value) => setAccepted((prev) => ({ ...prev, [type]: value }))}
                    />
                )}

                <button type="submit" disabled={loading || !docs || !accepted.cgu || !accepted.dpa}>
                    {loading ? 'Inscription en cours...' : 'S\'inscrire'}
                </button>
            </form>

            <p>
                Vous avez déjà un compte ? <Link to="/signin">Se connecter</Link>
            </p>
        </div>
    );
};

export default SignUp;
